import { useEffect, useRef, useState } from 'react';
import { getClients } from '../services/api';

const fallbackClients = [
  { id: 13, name: 'Petrosea', logo: 'https://manufacture-api.afsreman.com/storage/our-clients/petrosea/logo-petrosea.png', website: 'https://petrosea.com/id/' },
  { id: 1, name: 'PT Industri Manufaktur Indonesia', logo: null, website: 'https://industrimanufaktur.co.id' },
  { id: 2, name: 'CV Mesin Sejahtera', logo: null, website: 'https://mesinsejahtera.com' },
  { id: 3, name: 'PT Teknik Jaya Abadi', logo: null, website: 'https://teknikjaya.co.id' },
  { id: 4, name: 'PT Konstruksi Prima', logo: null, website: 'https://konstruksiprima.com' },
  { id: 5, name: 'PT Otomotif Nusantara', logo: null, website: 'https://otomotifnusantara.co.id' },
  { id: 6, name: 'CV Karya Teknik', logo: null, website: 'https://karyateknik.com' },
  { id: 7, name: 'PT Energi Hijau Indonesia', logo: null, website: 'https://energihijau.co.id' },
  { id: 8, name: 'PT Mitra Industri Bersama', logo: null, website: 'https://mitraindustri.com' },
  { id: 10, name: 'PT Sinergi Manufaktur', logo: null, website: 'https://sinergimanufaktur.com' },
  { id: 9, name: 'PT Teknologi Modern', logo: null, website: 'https://teknomodern.co.id' },
  { id: 11, name: 'PT Global Industries', logo: null, website: 'https://globalindustries.co.id' },
  { id: 12, name: 'CV Presisi Engineering', logo: null, website: 'https://presisiengineering.com' },
];

const Clients = () => {
  const sectionRef = useRef(null);
  const [clients, setClients] = useState(fallbackClients);

  useEffect(() => {
    getClients().then(data => {
      if (data && data.length > 0) {
        const mapped = data.map(c => ({
          id: c.id,
          name: c.name,
          logo: c.logo || null,
          website: c.website || null,
        }));
        setClients(mapped);
      }
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if(e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    const els = sectionRef.current.querySelectorAll('.rv');
    els.forEach(el => observer.observe(el));
    return () => els.forEach(el => observer.unobserve(el));
  }, [clients]);

  // Split clients into two rows and double for infinite marquee
  const midpoint = Math.ceil(clients.length / 2);
  const row1 = clients.slice(0, midpoint);
  const row2 = clients.slice(midpoint);
  const doubled1 = [...row1, ...row1];
  const doubled2 = [...row2, ...row2];

  return (
    <section id="clients" ref={sectionRef}>
      <div className="clients-hdr wrap rv">
        <div className="slide-index" style={{color:'var(--yd)',justifyContent:'center'}}><span></span> Trusted Partners</div>
        <h2 className="heading" style={{textAlign:'center'}}>Our <em>Clients</em></h2>
        <p style={{color:'var(--mid)',fontSize:'15px',maxWidth:'460px',margin:'14px auto 0',lineHeight:'1.75',textAlign:'center'}}>Trusted by leading industrial companies across Indonesia for reliable engineering and remanufacturing solutions.</p>
      </div>
      <div style={{marginTop:'40px',display:'flex',flexDirection:'column',gap:'20px'}}>
        {/* Row 1 - Left to Right */}
        <div className="marquee-outer">
          <div className="marquee-track">
            {doubled1.map((client, i) => (
              <div className="c-logo" key={`r1-${i}`}>
                {client.logo ? (
                  <img src={client.logo} alt={client.name} style={{height:'36px',maxWidth:'120px',objectFit:'contain'}} />
                ) : (
                  <div className="c-logo-chip">{client.name}</div>
                )}
              </div>
            ))}
          </div>
        </div>
        
        {/* Row 2 - Right to Left */}
        <div className="marquee-outer">
          <div className="marquee-track marquee-reverse">
            {doubled2.map((client, i) => (
              <div className="c-logo" key={`r2-${i}`}>
                {client.logo ? (
                  <img src={client.logo} alt={client.name} style={{height:'36px',maxWidth:'120px',objectFit:'contain'}} />
                ) : (
                  <div className="c-logo-chip">{client.name}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Footer Info */}
      <div className="wrap" style={{textAlign:'center',marginTop:'48px'}}>
        <h2 className="heading" style={{textAlign:'center',fontSize:'clamp(28px,3.5vw,44px)',color:'var(--y)',marginBottom:'12px'}}>
          13+ Clients &amp; Partners
        </h2>
        <p style={{fontSize:'15px',color:'var(--mid)',margin:'0'}}>Displayed are some of our key partners.</p>
      </div>
    </section>
  );
};

export default Clients;